/* MONTRELIO — catalogue partagé des quiz (01.10.2026).
   Lit l'index /collections/all?view=quizindex (templates/collection.quizindex.liquid),
   le met en cache 30 min dans sessionStorage, et dérive pour chaque montre des clés
   simples : univers, styles, mouvement, étanchéité, bracelet, métal, gamme, nouveauté,
   avantages. Utilisé par sections/montrelio-quiz.liquid et sections/montrelio-tri.liquid.
   (« Ma sélection » retirée le 01.10, décision Mathieu.) */
(function () {
  if (window.MtrCatalogue) return;
  var KEY = 'mtr_idx_v2', TTL = 30 * 60 * 1000;

  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function has(txt, re) { return re.test(txt); }

  function atmOf(et) {
    var e = norm(et);
    if (!e) return -1;
    if (e.indexOf('non') !== -1) return 0;
    var m = e.match(/(\d+(?:[.,]\d+)?)\s*(atm|bar)/);
    if (m) return parseFloat(m[1].replace(',', '.'));
    m = e.match(/(\d+)\s*m\b/);
    if (m) return Math.round(parseInt(m[1], 10) / 10);
    return -1;
  }

  function accessoire(x) { return /remontoir|boite|etui|bracelet|coffret/.test(norm(x.ty)); }

  function derive(x) {
    var titre = norm(x.t), type = norm(x.ty), tags = norm(x.tg).replace(/\|/g, ' ; ');
    var txt = titre + ' ' + type + ' ' + tags;
    var ge = norm(x.ge), ag = norm(x.ag), mvt = norm(x.mv), band = norm(x.bd);
    var ado = (' ' + titre + ' ').indexOf(' ado ') !== -1 || type.indexOf(' ado') !== -1;
    var u = 'h';
    if (ado || has(txt, /enfant|garcon|fille|pedagogique|educative/) || ag.indexOf('enfant') !== -1 || ag.indexOf('ado') !== -1) u = 'e';
    else if (has(titre + ' ' + type, /femme/) || ge.indexOf('femin') !== -1) u = 'f';
    else if (ge.indexOf('unisex') !== -1 || has(titre, /unisexe|mixte/)) u = 'x';

    var connectee = has(txt, /connecte|smart|gps|4g/) || mvt.indexOf('connect') !== -1;
    var mv = '';
    if (connectee) mv = 'connect';
    else if (mvt.indexOf('automatique') !== -1 || has(titre, /automatique/)) mv = 'auto';
    else if (mvt.indexOf('manuel') !== -1 || mvt.indexOf('mecanique') !== -1 || has(titre, /mecanique/)) mv = 'meca';
    else if (mvt.indexOf('solaire') !== -1 || has(titre, /solaire/)) mv = 'solaire';
    else if (mvt.indexOf('numerique') !== -1 && mvt.indexOf('analog') === -1) mv = 'digital';
    else if (mvt.indexOf('quartz') !== -1 || has(titre, /quartz/)) mv = 'quartz';
    var digital = mv === 'digital' || has(titre, /digital|led\b/);

    var bd = '';
    if (has(band, /cuir/)) bd = 'cuir';
    else if (has(band, /nylon|tissu|toile|nato/)) bd = 'nylon';
    else if (has(band, /silicone|caoutchouc|resine|plastique|pu\b/)) bd = 'silicone';
    else if (has(band, /ceram/)) bd = 'ceramique';
    else if (has(band, /bois/)) bd = 'bois';
    else if (has(band, /acier|inox|metal|maille|alliage|titane/)) bd = 'acier';

    var metal = '';
    if (has(tags, /montre (femme|homme) or\b/) || has(titre, /\bdore|\bor\b|or rose/)) metal = 'or';
    if (has(tags, /montre (femme|homme) argent/) || has(titre, /argent|acier/)) metal = metal ? 'bicolore' : 'acier';

    var st = {
      classique: has(txt, /luxe|elegan|classique|minimal|habill|business|ultra.?fine|raffine|bijou|chic/) || type.indexOf('luxe') !== -1,
      sport: has(txt, /sport|chrono|militaire|plong|digital|solaire|racing|outdoor|gmt|tactique|commando/),
      vintage: has(txt, /vintage|retro|gousset|romain|aviateur|art deco|antique/),
      connectee: connectee,
      bois: has(txt, /\bbois\b|bambou/),
      squelette: has(txt, /squelet/),
      gousset: has(txt, /gousset/)
    };

    var gamme = '';
    var gm = tags.match(/gamme-([a-z-]+)/);
    if (gm) gamme = gm[1];

    var av = String(x.av || '').split(/\n+/).map(function (l) {
      var parts = l.split(/\s+[—–-]\s+/);
      return parts.length > 1 ? { t: parts[0].trim(), s: parts.slice(1).join(', ').trim() } : { t: l.trim(), s: '' };
    }).filter(function (a) { return a.t; });

    var now = Date.now() / 1000;
    return {
      h: x.h, titre: x.t, url: '/products/' + x.h, img: x.i, img2: x.i2, r: x.r,
      prix: x.p / 100, barre: x.c > x.p ? x.c / 100 : 0, ok: x.ok, variant: x.v,
      u: u, ado: ado, mv: mv, digital: digital, atm: atmOf(x.et), et: x.et, d: x.d,
      diam: parseFloat(String(x.d || '').replace(',', '.')) || 0,
      bd: bd, bdTxt: x.bd, metal: metal, st: st, gamme: gamme,
      neuf: tags.indexOf('nouveautes') !== -1 || (now - x.cr) < 45 * 86400,
      educative: has(txt, /educati|pedagog|apprentissage|apprendre/),
      garcon: has(txt, /garcon/), fille: has(txt, /fille/),
      petit: has(titre, /\b[345] ans\b/),
      av: av, col: (x.col || []).map(function (c) { return { n: c[0], hex: c[1] }; }),
      txt: txt
    };
  }

  var promesse = null;
  function load() {
    if (promesse) return promesse;
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && Date.now() - c.at < TTL && c.items && c.items.length) {
        promesse = Promise.resolve(c.items.filter(function (x) { return !accessoire(x); }).map(derive));
        return promesse;
      }
    } catch (e) {}
    function page(n) {
      return fetch('/collections/all?view=quizindex&sort_by=best-selling&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); });
    }
    promesse = page(1).then(function (p1) {
      var autres = [];
      for (var n = 2; n <= (p1.pages || 1) && n <= 6; n++) autres.push(page(n));
      return Promise.all(autres).then(function (rest) {
        var items = p1.items.concat.apply(p1.items, rest.map(function (p) { return p.items || []; }));
        try { sessionStorage.setItem(KEY, JSON.stringify({ at: Date.now(), items: items })); } catch (e) {}
        return items.filter(function (x) { return !accessoire(x); }).map(derive);
      });
    }).catch(function () { promesse = null; return []; });
    return promesse;
  }

  function money(v) { return v.toFixed(2).replace('.', ',') + ' €'; }

  function track(ev, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: ev };
      Object.keys(params || {}).forEach(function (k) { o[k] = params[k]; });
      window.dataLayer.push(o);
      if (typeof window.gtag === 'function') window.gtag('event', ev, params || {});
    } catch (e) {}
  }

  window.MtrCatalogue = { load: load, derive: derive, norm: norm, money: money, track: track };
})();
